var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7617 2.57527L19.3517 1.16527L16.5017 4.37527C14.4417 2.05527 11.5917 0.655273 8.37172 0.655273C5.48172 0.655273 2.83172 1.81527 0.761719 3.65527L2.18172 5.07527C3.88172 3.58527 6.03172 2.65527 8.37172 2.65527C11.1117 2.65527 13.4617 3.91527 15.1417 5.89527L12.2617 9.13527L8.26172 5.13527L0.761719 12.6453L2.26172 14.1453L8.26172 8.13527L12.2617 12.1353L16.3117 7.58527C17.0617 8.93527 17.5617 10.4853 17.7517 12.1353H19.7617C19.5417 9.83527 18.8117 7.74527 17.7217 5.99527L20.7617 2.57527Z",
    fill: "#5926F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeRate);
export default __webpack_public_path__ + "static/media/exchange_rate.e9130e29cea3c0fdebe9aea4f4edd8f9.svg";
export { ForwardRef as ReactComponent };